"use client";

import { Card, CardContent } from "@workspace/ui/components/card";
import { memo } from "react";

interface SetVideoCardProps {
	youtubeUrl: string;
}

// Utility function to extract YouTube video ID from various URL formats
const extractYouTubeVideoId = (url: string): string | null => {
	const patterns = [
		/youtu\.be\/([a-zA-Z0-9_-]{11})/,
		/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
		/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
		/youtube\.com\/v\/([a-zA-Z0-9_-]{11})/,
		/youtube\.com\/live\/([a-zA-Z0-9_-]{11})/,
	];

	for (const pattern of patterns) {
		const match = url.match(pattern);
		if (match?.[1]) return match[1];
	}
	return null;
};

export const SetVideoCard = memo<SetVideoCardProps>(({ youtubeUrl }) => {
	const videoId = extractYouTubeVideoId(youtubeUrl);

	if (!videoId) {
		return null;
	}

	return (
		<Card>
			<CardContent className="p-3">
				<div className="aspect-video w-full">
					<iframe
						src={`https://www.youtube.com/embed/${videoId}`}
						title="Set Video"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						className="h-full w-full rounded-lg"
					/>
				</div>
			</CardContent>
		</Card>
	);
});

SetVideoCard.displayName = "SetVideoCard";
